module.exports = __webpack_public_path__ + "static/bg-1-0ad965d19972599d04a7a43b896b76cc.png";